import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function LoginModal({ onLogin }) {
  const [emailInput, setEmailInput] = useState('');
  const [showError, setShowError] = useState(false);

  const handleSubmit = async () => {
    console.log('Submit button clicked');
    
    if (emailInput.includes('@')) {
      try {
        const response = await fetch(`${window.location.origin}/api/login.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({ email: emailInput }),
        });

        if (response.ok) {
          onLogin(emailInput);
        } else {
          console.error('Login failed. Please try again.');
          setShowError(true);
        }
      } catch (error) {
        console.error('An error occurred:', error);
        setShowError(true);
      }
    } else {
      alert('Please enter a valid email address.');
    }
  };

  return (
    <Modal show centered>
      <Modal.Header>
        <Modal.Title>Enter your business email to enter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Business email address</Form.Label>
            <Form.Control
              type="email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              placeholder="Enter your business email"
            />
            {showError && (
              <Form.Text className="text-danger">
                Login failed. Please try again.
              </Form.Text>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default LoginModal;
